import React from 'react';
import Home from "./Pages/Home";
import About from './Pages/About';
import { Routes,Route } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import Contactuspage from './Pages/Contactuspage';
import VisionMissionValue from './Pages/VisionMissionValue';
import PageNotFound from './components/PageNotFound/PageNotFound';
import ServicesPage from './Pages/ServicesPage';
import Clientele from './Pages/Clientele.js';
import Product_services from './Pages/Products_services.js';
import Automation_robotics from './Pages/Automation_robotics.js';
import EngineeringServicesPage from './Pages/Engineering_services.js';
import FixturesToolings from './Pages/FixturesToolings.js';
import ErgonomicLiftPage from './Pages/ergonomic.js';

const App = () => {
  return (
    <div>
      <ScrollToTop />
      <Routes>
        <Route path='/' element={<Home />}/>
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contactuspage />} />
        <Route path="/services" element={<ServicesPage/>} />
        <Route path="/visionmissionvalues" element={<VisionMissionValue/>} />
        <Route path="/clientele" element={<Clientele/>} />
        <Route path="/Products_services" element={<Product_services/>} />
        <Route path="/Automation_robotics" element={<Automation_robotics/>} />
        <Route path="/Engineering_services" element={<EngineeringServicesPage/>} />
        <Route path="/FixturesToolings" element={<FixturesToolings/>} />  
        <Route path="/ergonomic" element={<ErgonomicLiftPage />} />  
        <Route path="*" element={<PageNotFound/>} />
      </Routes>
    </div>
  )
};

export default App;